import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectList = createSelector(getEinreichungState, (state: EinreichungState) => state.applicationsList.list);
export const selectListLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsList.loading,
);
export const selectListError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsList.error,
);
